export default "__VITE_ASSET__NYIMG3Ff__"